'use es6';

import * as ActionTypes from '../actions/ActionTypes';

const trackingParams = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.APP_STARTED:
      {
        return Object.assign({}, action.payload.trackingParams);
      }

    default:
      return state;
  }
};

export default trackingParams;